import { createContext, useContext, useEffect, useRef } from "react";

/*
 * The card side of the logistics update launcher: the context and the two hooks cards and screens
 * use. Kept apart from the provider so a card does not pull in the auth module and the dialog.
 */

const NO_LAUNCHER = { canUpdate: () => false, open: () => {}, subscribe: () => () => {} };

export const LogisticsUpdateLauncherContext = createContext(NO_LAUNCHER);

/**
 * @returns {{ canUpdate: (item: object) => boolean, open: (item: object) => void }} outside a
 *   provider, `canUpdate` is always false
 */
export const useLogisticsUpdateLauncher = () => useContext(LogisticsUpdateLauncherContext);

/**
 * Runs `onUpdated` after a logistics update started from a card's menu has been saved. For
 * screens that keep their lists in their own state; lists cached by React Query are refreshed
 * without it.
 *
 * @param {() => void} onUpdated
 */
export const useLogisticsProgressUpdated = (onUpdated) => {
  const { subscribe } = useContext(LogisticsUpdateLauncherContext);
  const callbackRef = useRef(onUpdated);
  callbackRef.current = onUpdated;

  useEffect(() => subscribe(() => callbackRef.current?.()), [subscribe]);
};
